<script type="ts">
    import { v4 as uuidv4 } from 'uuid';
    import { createEventDispatcher, onMount } from 'svelte';

    const dispatch = createEventDispatcher();

    let id: string = uuidv4();
    export let text: string;
    export let value = '';
    export let type: 'text' | 'email';
    export let required = false;
    export let isValid = false;

    let validated = false;
    let validationMessage = '';

    function validate()
    {
        validated = true;
        isValid = true;
        validationMessage = '';

        if (required)
        {
            if (value === '')
            {
                isValid = false;
                validationMessage = 'Ce champ est obligatoire.';
                dispatch('validation', { id, valid: isValid });
                return;
            }
        }
        else if (value === '')
        {
            return;
        }

        switch (type)
        {
            case 'text':
                break;
            case 'email':
                if (!validateEmail(value))
                {
                    isValid = false;
                    validationMessage = 'Veuillez entrer un email valide.';
                    dispatch('validation', { id, valid: isValid });
                    return;
                }
                break;
        }

        isValid = true;
        validationMessage = '';
        dispatch('validation', { id, valid: isValid });
    }

    function validateEmail(value: string)
    {
        return (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value));
    }

    onMount(() =>
    {
        if (value !== '')
        {
            validate();
        }
    });
</script>

<style>
    .errorMessage
    {
        color: red;
    }
</style>

<div class="form-group">
    <label for={id}>{text}</label>
    <input type="text" class={"form-control " + type} id={id} placeholder={text} bind:value={value} on:change={validate}>
    {#if !isValid}
        <span class="errorMessage">{validationMessage}</span>
    {/if}
</div>